"use strict";
/**
 * Default values for FiltersJson - shared between server and client.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FILTERS_JSON = void 0;
const constants_1 = require("./constants");
exports.DEFAULT_FILTERS_JSON = {
    age_min: constants_1.DEFAULT_MIN_AGE,
    age_max: constants_1.DEFAULT_MAX_AGE,
    distance_max_km: constants_1.DEFAULT_MAX_DISTANCE_KM,
};
